import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=ea6c51e8&scoped=true&"
import script from "./loginFooter.vue?vue&type=script&lang=js&"
export * from "./loginFooter.vue?vue&type=script&lang=js&"
import style0 from "./loginFooter.vue?vue&type=style&index=0&id=ea6c51e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6c51e8",
  null
  
)

export default component.exports